/**
 * Zweck: Beschreibt class DtpZusatzdatentyp und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/dtp-zusatzdatentyp.ts.
 */
export class DtpZusatzdatentyp {
  Matchcode: string;
  Bezeichnung: string;
  ZusatzdatenBasistyp: string;
  PdfGeschwaerzt: boolean;
  Erforderlichkeit: string;
}
